module.exports = __webpack_public_path__ + "static/img/tellamamos.aab1eea3.jpeg";